module.exports = __webpack_public_path__ + "static/img/91012D_1_R_2020821_fit.0796790.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/91012D_1_R_2020821_fit.png
// module id = y1HV
// module chunks = 0